<template>
  <LayoutStack
    align-items="center"
    class="mx-auto"
    :class="{ 'my-auto': expand, [paddingClass]: true }"
    justify-content="center"
    :spacing="4"
  >
    <VProgressCircular indeterminate :size="size" width="4" />
    <slot name="default">
      <span v-if="text" class="text-disabled">{{ text }}</span>
    </slot>
  </LayoutStack>
</template>

<script lang="ts" setup>
import { computed } from "vue";

type ProgressLoaderPadding = "none" | "small" | "medium" | "large";

interface ProgressLoaderProps {
  /** Whether loader should expand to fill space */
  expand?: boolean;
  padding?: ProgressLoaderPadding | number;
  /** Loader size */
  size?: number;
  text?: string;
}

const props = withDefaults(defineProps<ProgressLoaderProps>(), {
  expand: false,
  padding: "medium",
  size: 48,
  text: undefined,
});

const paddingMap: Record<ProgressLoaderPadding, number> = {
  none: 0,
  small: 4,
  medium: 8,
  large: 12,
};

const paddingClass = computed(() => {
  let paddingNumber = 0;
  if (typeof props.padding === "string") {
    paddingNumber = paddingMap[props.padding];
  } else if (typeof props.padding === "number") {
    paddingNumber = props.padding;
  }

  return paddingNumber ? `pa-${paddingNumber}` : "";
});
</script>
